"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DependencyInstallation = exports.InstallationStatus = exports.AppDependencies = exports.InstalledDependency = void 0;
var json2typescript_1 = require("json2typescript");
var InstalledDependency = (function () {
    function InstalledDependency(partial) {
        this.name = '';
        this.version = '';
        this.lastModified = 0;
        Object.assign(this, partial);
    }
    __decorate([
        (0, json2typescript_1.JsonProperty)('name'),
        __metadata("design:type", Object)
    ], InstalledDependency.prototype, "name", void 0);
    __decorate([
        (0, json2typescript_1.JsonProperty)('version'),
        __metadata("design:type", Object)
    ], InstalledDependency.prototype, "version", void 0);
    __decorate([
        (0, json2typescript_1.JsonProperty)('last_modified'),
        __metadata("design:type", Object)
    ], InstalledDependency.prototype, "lastModified", void 0);
    InstalledDependency = __decorate([
        (0, json2typescript_1.JsonObject)('InstalledDependency'),
        __metadata("design:paramtypes", [Object])
    ], InstalledDependency);
    return InstalledDependency;
}());
exports.InstalledDependency = InstalledDependency;
var AppDependencies = (function () {
    function AppDependencies(partial) {
        this.id = '';
        this.location = '';
        this.domainIdHash = 0;
        this.userId = '';
        this.lastModified = 0;
        this.dependenciesList = [];
        this.installedViaPackageManager = false;
        Object.assign(this, partial);
    }
    __decorate([
        (0, json2typescript_1.JsonProperty)('_id'),
        __metadata("design:type", Object)
    ], AppDependencies.prototype, "id", void 0);
    __decorate([
        (0, json2typescript_1.JsonProperty)('location'),
        __metadata("design:type", Object)
    ], AppDependencies.prototype, "location", void 0);
    __decorate([
        (0, json2typescript_1.JsonProperty)('domain_id_hash'),
        __metadata("design:type", Object)
    ], AppDependencies.prototype, "domainIdHash", void 0);
    __decorate([
        (0, json2typescript_1.JsonProperty)('user_id'),
        __metadata("design:type", Object)
    ], AppDependencies.prototype, "userId", void 0);
    __decorate([
        (0, json2typescript_1.JsonProperty)('last_modified'),
        __metadata("design:type", Object)
    ], AppDependencies.prototype, "lastModified", void 0);
    __decorate([
        (0, json2typescript_1.JsonProperty)('dependencies_list', [InstalledDependency]),
        __metadata("design:type", Array)
    ], AppDependencies.prototype, "dependenciesList", void 0);
    __decorate([
        (0, json2typescript_1.JsonProperty)('installed_via_package_manager'),
        __metadata("design:type", Object)
    ], AppDependencies.prototype, "installedViaPackageManager", void 0);
    AppDependencies = __decorate([
        (0, json2typescript_1.JsonObject)('AppDependencies'),
        __metadata("design:paramtypes", [Object])
    ], AppDependencies);
    return AppDependencies;
}());
exports.AppDependencies = AppDependencies;
var InstallationStatus;
(function (InstallationStatus) {
    InstallationStatus["Created"] = "created";
    InstallationStatus["Successful"] = "successful";
    InstallationStatus["Failed"] = "failed";
})(InstallationStatus = exports.InstallationStatus || (exports.InstallationStatus = {}));
var DependencyInstallation = (function () {
    function DependencyInstallation(partial) {
        this.id = '';
        this.appId = '';
        this.userId = '';
        this.updatedAt = 0;
        this.status = InstallationStatus.Created;
        this.statusMessage = '';
        this.location = '';
        this.domainIdHash = 0;
        Object.assign(this, partial);
    }
    __decorate([
        (0, json2typescript_1.JsonProperty)('_id'),
        __metadata("design:type", Object)
    ], DependencyInstallation.prototype, "id", void 0);
    __decorate([
        (0, json2typescript_1.JsonProperty)('app_id'),
        __metadata("design:type", Object)
    ], DependencyInstallation.prototype, "appId", void 0);
    __decorate([
        (0, json2typescript_1.JsonProperty)('user_id'),
        __metadata("design:type", Object)
    ], DependencyInstallation.prototype, "userId", void 0);
    __decorate([
        (0, json2typescript_1.JsonProperty)('updated_at'),
        __metadata("design:type", Object)
    ], DependencyInstallation.prototype, "updatedAt", void 0);
    __decorate([
        (0, json2typescript_1.JsonProperty)('status'),
        __metadata("design:type", String)
    ], DependencyInstallation.prototype, "status", void 0);
    __decorate([
        (0, json2typescript_1.JsonProperty)('status_message'),
        __metadata("design:type", Object)
    ], DependencyInstallation.prototype, "statusMessage", void 0);
    __decorate([
        (0, json2typescript_1.JsonProperty)('location'),
        __metadata("design:type", Object)
    ], DependencyInstallation.prototype, "location", void 0);
    __decorate([
        (0, json2typescript_1.JsonProperty)('domain_id_hash'),
        __metadata("design:type", Object)
    ], DependencyInstallation.prototype, "domainIdHash", void 0);
    DependencyInstallation = __decorate([
        (0, json2typescript_1.JsonObject)('DependencyInstallation'),
        __metadata("design:paramtypes", [Object])
    ], DependencyInstallation);
    return DependencyInstallation;
}());
exports.DependencyInstallation = DependencyInstallation;
//# sourceMappingURL=Dependencies.js.map